import { Navigate } from 'react-router-dom';

import { NotFound } from '@ohpen/enso-ui';
import { withGuard } from '@ohpen/react-authz';
import {
  ProductsPage,
  BaseRatesPage,
  FeesPage,
  ErcProfilesPage,
  ImportsPage,
  ExportTemplatesPage,
  ChangeRequestsPage,
  ExclusiveProductsPage,
  ExchangeRatesPage,
  ProcurationFeesPage,
  LenderPage,
  FirmsPage,
  BrokersPage,
} from '../pages';

export const ROUTES = {
  home: {
    path: '/',
    element: <Navigate to="products" replace />,
  },
  lender: {
    path: 'lender',
    element: withGuard(<LenderPage />, { permissions: ['lenders:view'], flags: ['enableLender'] }),
  },
  firms: {
    path: 'firms',
    element: withGuard(<FirmsPage />, { permissions: ['firms:view'], flags: ['enableFirms'] }),
  },
  brokers: {
    path: 'brokers',
    element: withGuard(<BrokersPage />, { permissions: ['brokers:view'], flags: ['enableBrokers'] }),
  },
  procurationFees: {
    path: 'procuration-fees',
    element: withGuard(<ProcurationFeesPage />, { permissions: ['procurationFees:view'], flags: ['enableProcurationFees'] }),
  },
  products: {
    path: 'products',
    element: withGuard(<ProductsPage />, { permissions: ['products:view'] }),
  },
  rates: {
    path: 'rates',
    element: withGuard(<BaseRatesPage />, { permissions: ['baseRates:view'] }),
  },
  exchangeRates: {
    path: 'exchange-rates',
    element: withGuard(<ExchangeRatesPage />, { permissions: ['exchangeRates:view'], flags: ['enableExchangeRates'] }),
  },
  fees: {
    path: 'fees',
    element: withGuard(<FeesPage />, { permissions: ['fees:view', 'feeProfiles:view'] }),
  },
  erc: {
    path: 'erc',
    element: withGuard(<ErcProfilesPage />, { permissions: ['ercProfiles:view'] }),
  },
  imports: {
    path: 'imports',
    element: withGuard(<ImportsPage />, { permissions: ['imports:view'], flags: ['enableImports'] }),
  },
  changeRequests: {
    path: 'export-templates',
    element: withGuard(<ExportTemplatesPage />, { permissions: ['changeRequests:view'] }),
  },
  exportTemplates: {
    path: 'change-requests',
    element: withGuard(<ChangeRequestsPage />, { permissions: ['exportTemplates:view'] }),
  },
  exclusiveProducts: {
    path: 'exclusives',
    element: withGuard(<ExclusiveProductsPage />, { permissions: ['exclusivitySets:view'] }),
  },
  notFound: {
    path: '*',
    element: <NotFound />,
  },
};
